/* eslint-disable max-len */
import React from 'react';
import './subscribe-push-notification.m.css';

const getStatusText = (status) => {
  switch (status) {
    case 'granted':
      return 'You are already subscribed to push notifications from Bloomberg|Quint.';
    case 'denied':
      return 'Please unblock notifications from NDTV Profit in your browser setting to receive real-time updates. You can go to your browser settings --- Notification --- select Bloomberg|Quint.';
    case 'loading':
      return 'Loading...';
    case 'not_supported':
      return 'Currently, web push notifications are not compatible with this device and/or browser.';
  }
};

const UpperFoldContent = () => (
  <>
    <h2 styleName="heading">How to subscribe to push notifications on your mobile and desktop.</h2>
    <h3 styleName="sub-heading">Get breaking news alerts from NDTV Profit</h3>
    <div styleName="message">
      {`We'll be sending you important alerts throughout the day. You can manage them any time from
      your browser settings.`}
    </div>
    <div styleName="step-item">
      <span>Step 1 -</span>
      <span styleName="step-text">Click on the bell icon below.</span>
    </div>
    <div styleName="step-item">
      <span>Step 2 -</span>
      <span styleName="step-text">
        {`Click on "Allow" to subscribe to NDTV Profit notifications.`}
      </span>
    </div>
  </>
);

class SubscribePushNotification extends React.Component {
  constructor() {
    super();
    this.state = {
      hardAskStatus: 'loading',
      isSoftAskShown: null,
      loading: true,
      showAllowStep: false,
    };
    this.callWebPush = this.callWebPush.bind(this);
    this.setHardAskStatus = this.setHardAskStatus.bind(this);
    this.setSoftAskStatus = this.setSoftAskStatus.bind(this);
    this.showAllowNotificationStep = this.showAllowNotificationStep.bind(this);
  }

  componentDidMount() {
    this.callWebPush();
    this.setSoftAskStatus();
    this.setHardAskStatus();
    this.showAllowNotificationStep();
  }

  callWebPush() {
    global.Moengage &&
      global.Moengage.call_web_push({
        soft_ask: true,
        main_class: 'moe-main-class',
        allow_class: 'moe-allow-class',
        block_class: 'moe-block-class',
      });
  }

  setHardAskStatus() {
    const moeData = JSON.parse(global.localStorage.getItem('MOE_DATA')) || {};
    moeData.HARD_ASK_STATUS && this.setState({ hardAskStatus: moeData.HARD_ASK_STATUS });
    if (
      !moeData.HARD_ASK_STATUS &&
      moeData.browserDetails &&
      (moeData.browserDetails.name === 'Apple Safari' || !('Notification' in global))
    ) {
      this.setState({ hardAskStatus: 'not_supported' });
    }
  }

  setSoftAskStatus() {
    global.addEventListener('MOE_OPT_IN', (e) => {
      e.detail === 'soft_ask_shown' && this.setState({ isSoftAskShown: true });
    });
  }

  showAllowNotificationStep() {
    global.addEventListener('MOE_OPT_IN', (e) => {
      e.detail === 'soft_ask_allowed' && this.setState({ showAllowStep: true });
    });
  }

  render() {
    return (
      <div className="container">
        <div styleName="content">
          <div className="moe-main-class">
            <UpperFoldContent />
            <div styleName="bell-icon">
              <i className="moe-allow-class icon-ic_notification_circle_glow" />
            </div>
          </div>
          <div styleName="status-text">
            {!this.state.isSoftAskShown && getStatusText(this.state.hardAskStatus)}
          </div>
          {this.state.showAllowStep && (
            <div styleName="status-text">
              {`Click on "Allow" to subscribe to Bloomberg|Quint notifications.`}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export { SubscribePushNotification };
